import React from 'react';
import { VIP_URL } from '@constants';
import addComponent from '@utils/addComponent';
import Title from '@components/Title';
import Modal from '@components/Modal';
import Button from '@components/Button';

function showVipModal() {
  addComponent((remove) => {
    return (
      <Modal
        isOpen
        header={<Title>温馨提示</Title>}
        footer={
          <Button as="a" href={VIP_URL} target="_blank">
            去升级
          </Button>
        }
        onRequestClose={remove}
      >
        <div className="relative flex h-full flex-col items-center justify-center">
          <div className="mb-5 text-lg">无法使用该音乐</div>
          <div>该音乐为个人专业版/企业版会员专享，升级即可使用！</div>
        </div>
      </Modal>
    );
  });
}

export default showVipModal;
